import { EditPermissions } from '../../../../../../../shared/models';
import { getEditTypes } from '../../../delegatorUtils';
import { newStepValue } from '../../../../../services/flowBuilder/utils/constants';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { required } from '../../../../../../../shared/utils';

export interface RichLinkFormData {
  menuHeader: string;
  url: string;
  title: string;
  image: string;
  previewType: string;
  videoUrl: string;
  videoMimeType: string;
  body: string;
  footer: string;
  next: string;
  menuMediaType: string;
  menuMediaLink: string;
}

export class RichLink {
  private menu: any = {};

  constructor() {
    this.menu = {
      'menuType': 'richLink',
    };
  }

  static toForm(stepData: { [index: string]: any }, editPermissions: EditPermissions): UntypedFormGroup {
    const {editMenuTextOnly, editFlows} = getEditTypes(editPermissions);
    const formData = this.getFromData(stepData);

    return this.buildForm(formData, editFlows);
  }

  private static getFromData(stepData: { [index: string]: any }): RichLinkFormData {
    const menu = stepData?.menu ? stepData?.menu : {};
    const menuParams = menu?.menuParams ? menu?.menuParams : {};
    const preview = menuParams?.preview ? menuParams?.preview : {};
    const whatsapp = menuParams?.whatsapp ? menuParams.whatsapp : {};
    const header = menu?.header ? menu.header : undefined;

    let menuHeader = this.getOrDefault(menu?.menuHeader);
    let menuMediaType = '';
    let menuMediaLink = '';

    if (header) {
      if (header.type === 'text') {
        menuHeader = this.getOrDefault(header.text);
      } else if (header.type === 'media') {
        menuHeader = '';
        menuMediaType = this.getOrDefault(header.media?.type);
        menuMediaLink = this.getOrDefault(header.media?.link);
      }
    }

    return {
      menuHeader: menuHeader,
      url: this.getOrDefault(menu?.url),
      title: this.getOrDefault(menuParams?.title),
      image: this.getOrDefault(preview?.image),
      previewType: preview?.previewType ? preview.previewType : 'IMAGE',
      videoUrl: this.getOrDefault(preview?.videoUrl),
      videoMimeType: this.getOrDefault(preview?.videoMimeType),
      body: this.getOrDefault(whatsapp?.body),
      footer: this.getOrDefault(whatsapp?.footer),
      next: stepData.next ? stepData.next : newStepValue,
      menuMediaType,
      menuMediaLink
    };
  }

  private static getOrDefault(value: string, defaultValue: any = ''): any {
    if (value === undefined || !value) {
      return defaultValue;
    }

    return value;
  }

  private static buildForm(formData: RichLinkFormData, editFlows: boolean): UntypedFormGroup {
    return new UntypedFormGroup({
      menuHeader: new UntypedFormControl({
        value: formData.menuHeader,
        disabled: !editFlows
      }),
      menuMediaType: new UntypedFormControl({
        value: formData.menuMediaType,
        disabled: !editFlows
      }),
      menuMediaLink: new UntypedFormControl({
        value: formData.menuMediaLink,
        disabled: !editFlows
      }),
      url: new UntypedFormControl({
        value: formData.url,
        disabled: !editFlows
      }, required('URL')),
      title: new UntypedFormControl({
        value: formData.title,
        disabled: !editFlows
      }, required('Title')),
      image: new UntypedFormControl({
        value: formData.image,
        disabled: !editFlows
      }),
      previewType: new UntypedFormControl({
        value: formData.previewType,
        disabled: !editFlows
      }),
      videoUrl: new UntypedFormControl({
        value: formData.videoUrl,
        disabled: !editFlows
      }),
      videoMimeType: new UntypedFormControl({
        value: formData.videoMimeType,
        disabled: !editFlows
      }),
      body: new UntypedFormControl({
        value: formData.body,
        disabled: !editFlows
      }),
      footer: new UntypedFormControl({
        value: formData.footer,
        disabled: !editFlows
      }),
      next: new UntypedFormControl({
        value: formData.next,
        disabled: !editFlows
      })
    });
  }

  public setMenu(rawData): void {
    const menu = {
      ...this.menu,
      menuHeader: rawData.menuHeader,
      url: rawData.url
    };

    if (rawData.menuMediaLink && rawData.menuMediaType) {
      menu['header'] = {
        type: 'media',
        media: {
          type: rawData.menuMediaType,
          link: rawData.menuMediaLink
        }
      };
    } else if (rawData.menuHeader) {
      menu['header'] = {
        type: 'text',
        text: rawData.menuHeader
      };
    }

    const preview = {};

    preview['image'] = rawData.image;
    preview['previewType'] = rawData.previewType;

    if (rawData.previewType === 'VIDEO') {
      preview['videoUrl'] = rawData.videoUrl;
      preview['videoMimeType'] = rawData.videoMimeType;
    }

    const whatsapp = {};

    whatsapp['body'] = rawData.body;
    whatsapp['footer'] = rawData.footer;

    const title = rawData.title;

    const menuParams = {
      title,
      preview,
      whatsapp
    };

    this.menu = {
      ...menu,
      menuParams
    };
  }

  get nodeData(): {} {
    return {
      menu: this.menu,
      'type': 'menu',
      metadata: {
        nodeVersion: '1.0.0'
      }
    };
  }
}
